;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Router = APP.module('Router');
	
	Router.Root = Marionette.AppRouter.extend({
		appRoutes: {
			'logout': 'logout',
			'*notFound': 'notFound'
		}
	});


}(window, APP, Backbone, Marionette, $, _));